import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TemplateService } from '../../../../../../core/src/lib/template.service';
import { MessageTemplate } from '@vendasta/conversation';
import { Scrollable } from '@vendasta/rx-utils';
import { BehaviorSubject, catchError, map, of } from 'rxjs';
import { TEMPLATES_PAGE_SIZE } from '../../../../../../core/src/lib/inbox.constants';
import { InboxService } from '../../../../../../core/src/lib/inbox.service';
import { ACCOUNT_GROUP_ID_TOKEN } from '../../../../../../core/src/lib/tokens';
import { toSignal } from '@angular/core/rxjs-interop';
import { InboxAtlasRoute } from '../../../../../../core/src/lib/interface/inbox.interface';
import { INBOX_TEMPLATES_ROUTER_LINK } from '../../../../../src/constants';

@Component({
  selector: 'inbox-insert-template',
  templateUrl: './inbox-insert-template.component.html',
  styleUrls: ['./inbox-insert-template.component.scss'],
})
export class InboxInsertTemplateComponent {
  private scrollable: Scrollable<MessageTemplate, null> = this.getScrollableList();
  protected readonly templates$ = this.scrollable.items$;

  private loading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  readonly loading$ = this.loading$$.asObservable();

  private readonly templateService = inject(TemplateService);
  private readonly inboxService = inject(InboxService);
  private readonly accountGroupId = toSignal(inject(ACCOUNT_GROUP_ID_TOKEN));

  readonly isBusinessApp = this.inboxService.isBusinessApp;

  constructor(private readonly dialogRef: MatDialogRef<InboxInsertTemplateComponent>) {}

  getEditRoute(): string | InboxAtlasRoute {
    if (this.isBusinessApp) {
      return `/account/location/${this.accountGroupId()}/settings/message-templates`;
    }
    return INBOX_TEMPLATES_ROUTER_LINK;
  }

  selectTemplate(template: MessageTemplate): void {
    this.dialogRef.close(template);
  }

  loadNext(): void {
    this.scrollable.loadMore();
  }

  private getScrollableList() {
    return new Scrollable<MessageTemplate, null>(of(null), (_, cursor) => {
      return this.loadMore(cursor);
    });
  }

  loadMore(cursor: string) {
    return this.templateService.listTemplates(cursor, TEMPLATES_PAGE_SIZE).pipe(
      map((response) => {
        this.loading$$.next(false);
        return {
          items: response.templates,
          cursor: response.pagingMetadata?.nextCursor ?? '',
          hasMore: response.pagingMetadata?.hasMore ?? false,
        };
      }),
      catchError(() => of({ items: [] as Array<MessageTemplate>, cursor: '', hasMore: false })),
    );
  }
}
